import { Globe2 } from 'lucide-react';

import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/components/ui/select';

import { countryName, useSelectedCountry } from '../hooks/use-selected-country';

/**
 * The Admin country selector in the header. Offers only countries in the
 * staff member's scope; with a single country there is nothing to choose, so
 * it shows that country as a label.
 */
export function CountrySelector() {
  const { countries, country, select } = useSelectedCountry();

  if (!country) {
    return <span className="text-muted-foreground px-2 text-xs">No country assigned</span>;
  }

  if (countries.length === 1) {
    return (
      <span className="text-muted-foreground flex items-center gap-1.5 px-2 text-xs">
        <Globe2 className="size-3.5" aria-hidden />
        {countryName(country)}
      </span>
    );
  }

  return (
    <Select value={String(country.id)} onValueChange={(value) => select(Number(value))}>
      <SelectTrigger size="sm" className="h-8 gap-1.5 text-xs" aria-label="Country">
        <Globe2 className="size-3.5" aria-hidden />
        <SelectValue />
      </SelectTrigger>
      <SelectContent>
        {countries.map((option) => (
          <SelectItem key={option.id} value={String(option.id)}>
            {countryName(option)}
            {option.isActive ? '' : ' (inactive)'}
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
}
